
const ACCESS_TOKEN_KEY = "authtoken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USERNAME_KEY = "username";
const USER_ID = "userId";

export const setAccessToken = (token) => localStorage.setItem(ACCESS_TOKEN_KEY, token);
export const setRefreshToken = (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token);

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setStoredUsername = (username) => {if (username) localStorage.setItem(USERNAME_KEY, username);};

export const clearTokens = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem(USER_ID);
};